import { Icon, type IconName } from '../../icons/Icon';
import { Brand } from '../shared/parts';

const DESKTOP_POINTS: { icon: IconName; title: string; text: string }[] = [
  { icon: 'server', title: '대화와 파일은 회사 서버에 저장', text: '메시지와 파일은 회사가 운영하는 서버에 보관돼요.' },
  { icon: 'shield', title: '연결 전에 서버를 확인해요', text: 'HTTPS 인증서·서버 신원·버전 호환을 확인한 뒤에만 연결해요.' },
  { icon: 'external', title: '앱에서 열기로 간편하게', text: '가입을 마친 화면이나 다운로드 페이지에서 ‘앱에서 열기’를 누르면 주소가 자동으로 입력돼요.' },
];

const WEB_POINTS: { icon: IconName; title: string; text: string }[] = [
  { icon: 'server', title: '대화와 파일은 회사 서버에 저장', text: '메시지와 파일은 회사가 운영하는 서버에 보관돼요.' },
  { icon: 'shield', title: '회사 서버 계정으로 로그인', text: '클라우드 콘솔 계정과는 별개예요. 회사 관리자 계정은 2단계 인증을 써요.' },
  { icon: 'monitor', title: '데스크톱 앱도 있어요', text: 'Windows·macOS·Linux 앱에서 OS 알림과 트레이를 쓸 수 있어요.' },
];

/** Left `.cx-brand` panel (hidden below 1024px by the design CSS). */
export function ConnectBrand({ mode, companyName }: { mode: 'desktop' | 'web'; companyName: string | null }) {
  const points = mode === 'desktop' ? DESKTOP_POINTS : WEB_POINTS;
  return (
    <section className="cx-brand glass" aria-label="sd-messenger 소개">
      <Brand />
      {mode === 'desktop' ? (
        <h1>
          우리 회사 서버에
          <br />
          <em>바로 연결</em>해요
        </h1>
      ) : (
        <h1>
          {companyName ?? '우리 회사'} 메신저에
          <br />
          <em>로그인</em>해요
        </h1>
      )}
      <p>
        {mode === 'desktop'
          ? '하나의 앱으로 여러 회사 서버에 접속할 수 있어요. 회사마다 계정·대화·알림이 따로 관리돼요.'
          : '회사가 운영하는 메신저 서버에 바로 접속했어요. 초대받은 이메일과 비밀번호로 로그인하세요.'}
      </p>
      <div className="cx-points">
        {points.map((point) => (
          <div key={point.title}>
            <span className="ic">
              <Icon name={point.icon} />
            </span>
            <span>
              <b>{point.title}</b>
              {point.text}
            </span>
          </div>
        ))}
      </div>
      <div className="cx-bubbles" aria-hidden="true">
        <div className="bb">서연님, 오늘 리뷰 몇 시예요? 🙂</div>
        <div className="bb me">2시에 봬요!</div>
      </div>
    </section>
  );
}
